import { createSelector } from "reselect";
import { AppState } from "@shared/interfaces";

const selectMarketMapState = (state: AppState) => state.marketMap;

export const getMarketMap = () => createSelector(selectMarketMapState, (state) => state);

export const getMarketMapFiltersData = () => createSelector(selectMarketMapState, (state) => state.filters);

export const getCountyGeoData = () => createSelector(selectMarketMapState, (state) => state.countyGeoData);
